// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"cb5c6588","57":"293c5d68","124":"71d740b3","353":"813f002b","453":"db74b6f0","660":"dff304d2","697":"1dec0a87","712":"cb851c5d","791":"10d84f4a","819":"e854cf30"}[chunkId] + ".chunk.js";
};